export const escapeRegExp = (s: string) =>
  s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const detectDecimalChar = (input: string): string | null => {
  const lastDot = input.lastIndexOf('.');
  const lastComma = input.lastIndexOf(',');
  if (lastDot === -1 && lastComma === -1) return null;
  return lastDot > lastComma ? '.' : ',';
};

export const sanitizeInput = (
  input: string,
  decimalSeparator: string,
  groupSeparator: string,
  maximumFractionDigits: number
): string => {
  let result = '';
  let hasDecimal = false;

  const decimalChar = detectDecimalChar(input);
  const hasBothSeparators = input.includes('.') && input.includes(',');

  for (let i = 0; i < input.length; i++) {
    const char = input[i];
    const isLastChar = i === input.length - 1;

    if (char === '-' && i === 0) {
      result += '-';
      continue;
    }

    if (hasBothSeparators) {
      if (decimalChar && char === decimalChar && !hasDecimal) {
        result += decimalSeparator;
        hasDecimal = true;
        continue;
      }
      if ((char === '.' || char === ',') && decimalChar && char !== decimalChar) {
        continue;
      }
    } else {
      if (char === groupSeparator && !isLastChar) {
        const remaining = input.slice(i + 1);
        const digitsAfter = remaining.match(/^\d+/)?.[0]?.length ?? 0;
        if (digitsAfter > 2) {
          continue;
        }
      }
      if ((char === '.' || char === ',') && !hasDecimal) {
        result += decimalSeparator;
        hasDecimal = true;
        continue;
      }
    }

    if (char >= '0' && char <= '9') {
      result += char;
    }
  }

  if (!hasDecimal) return result;

  const [i, d = ''] = result.split(decimalSeparator);
  return `${i}${decimalSeparator}${d.slice(0, maximumFractionDigits)}`;
};

